import { render, staticRenderFns } from "./AdminDeliveries.vue?vue&type=template&id=3430e890&scoped=true&"
import script from "./AdminDeliveries.vue?vue&type=script&lang=js&"
export * from "./AdminDeliveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3430e890",
  null
  
)

export default component.exports